export const DEFAULT_LISTING_PAGE_SIZE = 25;
